"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageMeta = usePageMeta;
var react_1 = require("react");
var site_1 = require("@/config/site");
function setMeta(name, content, attr) {
    if (attr === void 0) { attr = "name"; }
    var el = document.querySelector("meta[".concat(attr, "=\"").concat(name, "\"]"));
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}
function usePageMeta(_a) {
    var title = _a.title, description = _a.description, _b = _a.path, path = _b === void 0 ? "/" : _b;
    (0, react_1.useEffect)(function () {
        document.title = title;
        setMeta("description", description);
        setMeta("og:title", title, "property");
        setMeta("og:description", description, "property");
        setMeta("twitter:title", title);
        setMeta("twitter:description", description);
        var canonical = "".concat(site_1.siteConfig.canonicalOrigin).concat(path === "/" ? "/" : path);
        var link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.rel = "canonical";
            document.head.appendChild(link);
        }
        link.href = canonical;
        setMeta("og:url", canonical, "property");
    }, [title, description, path]);
}
